import { render, staticRenderFns } from "./ManageProducts.vue?vue&type=template&id=a5cb7e2c&scoped=true&"
import script from "./ManageProducts.vue?vue&type=script&lang=js&"
export * from "./ManageProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cb7e2c",
  null
  
)

export default component.exports